import React from 'react'
import { withRouter } from 'react-router-dom';

import { Section, Table, InfosBar, Text, Empty, ProfilePicture } from 'components';
import { Button, Container, Dimmer, Loader, Icon } from 'semantic-ui-react'

import { Typeof } from 'utils';

import { API } from 'services';

const HORSES_PER_PAGE = 10;

class PaneHorses extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      horses: [],
      horseCriteria: ''
    };

    this.handleHorseReload = this.handleHorseReload.bind(this);
    this.handleHorseSearch = this.handleHorseSearch.bind(this);
    this.handleHorseSelect = this.handleHorseSelect.bind(this);
  }

  componentDidMount() {
    this.handleHorseReload();
  }

  handleHorseSelect(horse) {
    this.props.history.push(`/horses/${horse.uuid}`);
  }

  handleHorseSearch(criteria) {

    this.setState({
      horseCriteria: criteria
    });
  }

  handleHorseReload() {
    this.setState({
      loading: true
    }, () => {

      API.get(`clinics/${this.props.clinic.id}/horses`)
        .then((response) => {

          this.setState({
            horses: response.data,
            loading: false
          });

        })
        .catch(() => {

          this.setState({
            loading: false
          });

        })
    });
  }

  render() {

    const { horses } = this.state;


    let columns = [
      {
        id: 'picture',
        header: 'Photo',
        render: (horse) => {
          return (
            <ProfilePicture srcBase64={horse.picture} size="mini" />
          )
        },
        fit: true
      },
      {
        id: 'name',
        header: 'Nom',
        value: (horse) => horse.name,
        fit: true
      },
      {
        id: 'owner',
        header: 'Propriétaire',
        value: (horse) => horse.owner,
        render: (horse, owner) => {
          if(!Typeof.string(owner)) {
            return <Empty />;
          }

          return (
            <Text style={{"capitalize" : true}}>{owner}</Text>
          )
        },
        fit: true
      },
      {
        id: 'stable',
        header: 'Écurie',
        value: (horse) => horse.stable,
        render: (horse, stable) => {
          if(!Typeof.string(stable)) {
            return <Empty />;
          }

          return (
            <Text style={{"capitalize" : true}}>{stable}</Text>
          )
        }
      },
      {
        id: 'active',
        header: 'Actif',
        value: (horse) => horse.active,
        render: (horse, active) => {

          return (
            <Icon name={active ? 'checkmark' : 'times'} color={active ? 'green' : 'red'} />
          )
        },
        fit: true
      }
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Horses */}
          <Section title="Chevaux" onSearch={this.handleHorseSearch} actions={[
            <Button circular icon="sync" onClick={this.handleHorseReload} key={0} />
          ]}>

            {horses.length > 0 ? (

              <React.Fragment>

                {/* Number of available horses */}
                <InfosBar mode="column">
                  <span>{horses.length > 1 ? `${horses.length} chevaux disponibles` : '1 cheval disponible'}</span>
                </InfosBar>

                {/* horses list */}
                <Table columns={columns}
                  criteria={this.state.horseCriteria}
                  items={horses}
                  itemsPerPage={HORSES_PER_PAGE}
                  onSelect={this.handleHorseSelect}
                  messageEmpty="Aucun cheval ne correspond à votre recherche"
                />

              </React.Fragment>

            ) : (

              // No horse available
              <InfosBar mode="row">
                <span>Aucun cheval disponible</span>
              </InfosBar>

            )}

            <Dimmer active={this.state.loading} inverted>
              <Loader inverted>Chargement...</Loader>
            </Dimmer>

          </Section>

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(PaneHorses);
